import React from 'react';

import { Root } from './style';

function Row({ children }) {
  return <Root>{children}</Root>;
}

export default Row;
